import React, { useState, useRef } from 'react';
import { Link } from 'react-router-dom';

const galleryItems = [
    { 
    type: 'video',
    src: '/GalleryItems/belt-grinder-720p-h264.mp4',
    alt: 'Belt Grinder Demo',
    poster: '/GalleryItems/belt-grinder-720p-preview.jpg'
    },
    // { type: 'image', src: '/GalleryItems/IMG_9916.jpg', alt: 'Gallery Image 1' },
    // { type: 'image', src: '/GalleryItems/image-22.png', alt: 'Gallery Image 2' },
    // { type: 'image', src: '/GalleryItems/JyA1E5YNI32l.png', alt: 'Gallery Image 3' },
    // { type: 'video', src: '/GalleryItems/america-murica.mp4', alt: 'Gallery Video 1', poster: '/GalleryItems/america-murica-preview.jpg' },
];

const Gallery = () => {
  const [focusIdx, setFocusIdx] = useState<number|null>(null);
  const videoRefs = useRef<(HTMLVideoElement|null)[]>([]);

  React.useEffect(() => {
    if (focusIdx !== null && galleryItems[focusIdx].type === 'video') {
      const vid = videoRefs.current[focusIdx];
      if (vid) vid.pause();
    }
  }, [focusIdx]);

  React.useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setFocusIdx(null);
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, []);

  return (
    <section className="centered-section" id="gallery">
      <div className="translucent-box">
        <div style={{ marginBottom: '1.5rem', textAlign: 'left' }}>
          <Link to="/" className="main-link">&larr; Back to Home</Link>
        </div>
        <h2 style={{ fontSize: '2rem', fontWeight: 600, marginBottom: '1rem' }}>Gallery</h2>
        <div className="centered-section" style={{ width: '100%' }}>
          {galleryItems.map((item, idx) =>
            item.type === 'image' ? (
              <img
                key={item.src}
                src={item.src}
                alt={item.alt}
                style={{
                  width: '100%',
                  height: 'auto',
                  borderRadius: '0.5rem',
                  boxShadow: '0 2px 8px #0008',
                  cursor: 'pointer',
                  objectFit: 'contain'
                }}
                onClick={() => setFocusIdx(idx)}
              />
            ) : (
              <video
                key={item.src}
                src={item.src}
                controls
                style={{
                  width: '100%',
                  height: 'auto',
                  borderRadius: '0.5rem',
                  boxShadow: '0 2px 8px #0008',
                  cursor: 'pointer',
                  objectFit: 'contain'
                }}
              >
                Sorry, your browser does not support embedded videos.
              </video>
            )
          )}
        </div>
      </div>
      {focusIdx !== null && galleryItems[focusIdx].type === 'image' && (
        <div className="gallery-modal" onClick={() => setFocusIdx(null)}>
          <div className="gallery-modal-content" onClick={e => e.stopPropagation()}>
            <img src={galleryItems[focusIdx].src} alt={galleryItems[focusIdx].alt} style={{ maxWidth: '90vw', maxHeight: '80vh', borderRadius: '1rem' }} />
            <button className="gallery-modal-close" onClick={() => setFocusIdx(null)}>&times;</button>
          </div>
        </div>
      )}
    </section>
  );
};

export default Gallery;
